import { Chip, Stack, Typography } from '@mui/material';
import { Timer } from 'lucide-react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { differenceInMinutes } from 'date-fns';

interface Props {
  starts: number;
  ends?: number;
}

const OrderTimer = ({ starts, ends }: Props) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  const color = useMemo(() => {
    if (elapsedTime >= 45) return 'error';
    if (elapsedTime >= 30) return 'warning';
    return 'success';
  }, [elapsedTime]);

  const interval = useCallback((starts: number, ends?: number) => {
    if (ends) setElapsedTime(differenceInMinutes(ends, starts));
    setElapsedTime(differenceInMinutes(new Date(), starts));
  }, [])

  useEffect(() => {
    setInterval(interval, 5000, starts, ends);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!starts) return null;

  return (
    <Chip
      color={color}
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <Timer size={20} />
          <Typography variant="body2" sx={{ lineHeight: 'unset' }}>
            {elapsedTime}
          </Typography>
        </Stack>
      }
    />
  );
};

export default OrderTimer;
